<template>
  <div id="map-controls-sidebar-anchor">
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="activeAnchorVesselSidebar"
      class="items-no-padding"
    >
      <div class="h-full">
        <div
          class="customizer-header mt-6 flex items-center justify-between px-6"
        >
          <div>
            <span class="aisea-text-18-700-white">アンカー位置管理</span>
          </div>
          <feather-icon
            icon="XIcon"
            @click.stop="SET_ACTIVE_ANCHOR_VESSEL_SIDEBAR(false)"
            svgClasses="live-map-controls-close"
            class="cursor-pointer"
          ></feather-icon>
        </div>

        <vs-divider class="mb-0" color="#828282" />
        <anchor-vessel :settings="settings" :map="map" />
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
/**
 * LiveMapの作業船位置メニューと検索フォームを描画するコンポーネント
 * @parent MapControlsSidebar
 * @props map: Object マップのインスタンスデータ
 */
import AnchorVessel from "@/components/organisms/AnchorVessel";
import { createNamespacedHelpers } from "vuex";

const { mapState: mapStateOfLiveMap, mapMutations: mapMutationsOfLiveMap } =
  createNamespacedHelpers("liveMap");

export default {
  name: "O.SidebarAnchor",
  components: {
    AnchorVessel,
  },
  props: {
    map: Object,
  },
  data() {
    return {
      /** スクロールの設定 */
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  computed: {
    ...mapStateOfLiveMap({
      activeAnchorVesselSidebar: (state) => state.activeAnchorVesselSidebar,
    }),
  },
  methods: {
    ...mapMutationsOfLiveMap(["SET_ACTIVE_ANCHOR_VESSEL_SIDEBAR"]),
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
#map-controls-sidebar-anchor {
  .vs-sidebar {
    width: 400px;
    max-width: 90vw;
    background-color: $aisea-dark-blue;
    opacity: 1;
  }
}
</style>
